import { useQuery } from 'data-fetching-client';
import { GET_ALL_CLASSIC_FLOWS } from 'flow-doctor-lib/queries/FlowQueries';
const useWorkflowNameById = ({
  portalId,
  workflowId
}, {
  skip
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_ALL_CLASSIC_FLOWS, {
    variables: {
      portalId
    },
    skip
  });
  const dataToReturn = data ? data.alLClassicFlows.workflows.find(wfData => String(wfData.id) === String(workflowId)) : null;
  return {
    data: dataToReturn,
    loading,
    error
  };
};
export default useWorkflowNameById;